import it from "./it";

export default { it };



// WEBPACK FOOTER //
// ./src/messages/index.js